import React from 'react'
import styled from 'styled-components';

const BaseLine = styled.div`
  background: #CCEFF1;
  border-radius: 6px;
  height: 6px;
  width: 100%;
  position: relative;
`
const FilledLine = styled(BaseLine)`
  background: #00B97F;
  position: absolute;
  top: 0;
  left: 0;
  width: ${props => props.percent}%;
`

export default function LineChart ({ percent }) {
  return (
    <BaseLine>
      <FilledLine percent={percent} />
    </BaseLine>
  )
}
